<template>
    <div class="pop-up">
      <div class="pop-header">
        <span class="pop-title" v-html="popupTitle"></span>
        <button class="btn-pop-close" @click="$.emit('close')">닫기<span class="overlay"></span></button>
      </div>
      <div class="pop-body" v-html="popupText"></div>
      <div class="pop-btn-area">
        <button
          type="button"
          class="btn-pop btn-half btn-cancel"
          @click="$.emit('close')"
        >
          취소<span class="overlay"></span>
        </button>
        <button
          type="submit"
          class="btn-pop btn-half btn-submit"
          @click="$.emit('setYes')"
        >
          확인<span class="overlay"></span>
        </button>
      </div>
    </div>
    <div class="dimed"></div>
</template>
<script>
export default {
  name: "popupBtn2",
  props: {
    popupText: String,
    popupTitle: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>